<template>
  <div class="farsi">
    <v-card
      class="blue-grey lighten-5 mx-auto my-12"
      elevation="2"
      outlined
      width="500px"
      height="380px"
    >
      <v-alert color="blue-grey" dark dense icon="mdi-account-circle" prominent>
        ورود به سیستم ارسال مدارک اینترنتی
      </v-alert>
      <v-progress-linear
        class="my-0 pt=0"
        indeterminate
        height="3px"
        color="pink darken-1"
        :active="isshowing"
      >
      </v-progress-linear>

      <v-row>
        <v-col md="8 mx-auto mt-6   ">
          <v-form ref="form">
            <v-container class="farsi">
              <div v-if="!getcode">
                <div>شماره همراه خود را وارد کنید :</div>
                <v-text-field
                  autofocus
                  style="margin-top: 50px"
                  class="text-h6 mycenter"
                  v-model="user"
                  label=" شماره همراه"
                  ref="usser"
                  required
                  type="tel"
                  maxlength="11"
                  append-icon="mdi-cellphone"
                  v-on:keydown.enter.prevent="validate"
                ></v-text-field>

                <v-btn
                  id="step1"
                  class="mx-auto white--text blue-grey darken-2 mt-5 farsi"
                  width="300px"
                  @click.prevent="validate"
                >
                  ارسال رمز یکبار مصرف
                </v-btn>
              </div>
              <div dir="ltr" v-if="getcode">
                <div dir="rtl">کد را وارد کنید</div>
                <v-otp-input
                  id="myotp"
                  type="number"
                  ref="otpInput"
                  style="margin-top: 50px"
                  v-model="otp"
                  length="5"
                  @finish="onfinishotp"
                ></v-otp-input>
                <div dir="rtl" style="text-align: center">
                  زمان باقیمانده : &nbsp; {{ countdown }} &nbsp; ثانیه
                </div>

                <v-btn
                  :loading="isload"
                  id="step2"
                  class="mx-auto white--text blue-grey darken-2 mt-5 farsi"
                  width="300px"
                  @click.prevent="login2"
                >
                  تعیین اعتبار
                </v-btn>
              </div>
              <div
                id="appv"
                style=" display:flex; justify-content: space-between; height: 33px; width=300px"
              >
                <div>نگارش: {{ appversion }}</div>
                <div>
                  <span style="" dir="ltr"> {{ ipad }}</span
                  ><img
                    :class="ipad == '0.0.0.0' ? 'img2 red-image ' : 'img2'"
                    src="../assets/ip-address2.png"
                  />
                </div>
              </div>
              <vue-recaptcha
                ref="recaptcha"
                size="invisible"
                sitekey="6Lc9pcYkAAAAADbf48TYdJbb-MDu1fqj1-l5122R"
                @verify="register"
                @expired="onCaptchaExpired"
              ></vue-recaptcha>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-card>
    <div></div>
    <!--   <v-alert
     class="px-3  py-3"
      color="deep-orange lighten-2  mx-auto   mt-0"
      dark
      dense
        height="80px"
        width="180px"
      dismissible
      prominent
      elevation-3
      border="left"
    >
        رمز شما    54545454

    </v-alert>
 -->
  </div>
</template>

<script>
import axios from "axios";
import { VueRecaptcha } from "vue-recaptcha";
import { version } from "../../package";
export default {
  name: "Login",
  data() {
    return {
      countdown: 0,
      isfail: 0,
      isload: false,
      otp: "",
      getcode: false,
      baseaddress: "https://pz.ihiof.ir/apicap",
      ipad: "0.0.0.0",
      appversion: version,
      logg: 1,
      isshowing: false,
      user: "",
      pass: "",
      ostan: "1",
      ostanha: [
        { id: 1, name: "فارس" },
        { id: 2, name: "تست یک" },
      ],
    };
  },

  components: { VueRecaptcha },

  mounted() {
    let ss = this.baseaddress;
    let axiosConfig = {
      headers: {
        oss: this.ostan,
        Authorization: "Bearer " + localStorage.getItem("auth"),
      },
    };
    axios
      .get(
        ss + "/getmyipp",
        {
          user: this.user,
          pass: this.pass,
          os: this.ostan,
        },
        axiosConfig
      )
      .then((response) => {
        console.log("ddd", response);
        this.ipad = response.data.ip;
      })
      .catch((err) => {});
  },
  methods: {
    otpreader() {
      if ("OTPCredential" in window) {
        const ac = new AbortController();
        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
            signal: ac.signal,
          })
          .then((otp) => {
            console.log(otp.code);
            this.otp = otp.code;
            setTimeout(() => {
              this.login2();
            }, 500);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.log("WebOTP not supported!.");
      }
    },
    handleOnComplete(value) {
      console.log("OTP completed: ", value);
    },
    handleOnChange(value) {
      console.log("OTP changed: ", value);
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
    },
    register() {
      console.log("succesfull   register");
      this.login44();
    },

    validate() {
      // if validate true exec recaptcha
      this.$refs.recaptcha.execute();
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    keypress(e) {
      e.target.blur();
      console.log(e);
    },

    showtoast(txt) {
      this.$toast(txt, {
        toastClassName: "my-custom-toast-class",
        position: "bottom-center",
        timeout: 3000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: "button",
        icon: true,
        rtl: true,
      });
    },
    checklogin() {
      if (this.logg == 1) {
        return "نام کاربری و رمز عبور اشتباه است ";
      }
    },
    gotopass(user) {
      //  this.$refs.pass.focus();

      this.login4();
    },

    gotouser() {
      // document.activeElement.blur();
      //  this.$refs.usser.focus();
    },
    testdemo() {
      if (this.ostan == 200) {
        this.user = "1";
        this.pass = "1";

        this.$emit("startdemo", "1");
      }
    },

    retcheck(e) {
      if (e.keyCode === 13) {
        this.login2();
      }
    },

    onfinishotp() {
      console.log("finished");
      this.isload = true;
      this.login2();
    },

    login44() {
      console.log("hey testttttttt");

      let pattern = /((0?9)|(\+?989))\d{9}/g;

      if (!pattern.test(this.user)) {
        this.showtoast("شماره همراه معتبر نیست ");
        console.log("motabar nist");
        return;
      } else {
        this.login4();
      }
    },
    login4() {
      this.getcode = true;

      setTimeout(() => {
        console.log(document.getElementById("myotp--0"));
        document.getElementById("myotp--0").focus();
      }, 1000);
      this.countdown = 60;
      this.countDownTimer();
      this.otp = "";
      this.otpreader();
      this.pishlogin2();
    },

    countDownTimer() {
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.getcode = false;
        this.countdown = 60;
      }
    },

    login2() {
      this.isshowing = true;
      this.isload = false;

      if (this.ostan === "") {
        this.showtoast("انتخاب استان الزامی است ");

        return;
      }

      if (this.user === "") {
        this.showtoast("نام کاربری الزامی است ");

        return;
      }

      this.pass = this.otp;

      if (this.pass === "") {
        this.showtoast("  کد خالی است   ");

        return;
      }

      let axiosConfig = {
        headers: {
          oss: this.ostan,
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
      };

      var ss = window.location.protocol;
      if (ss == "https:") {
        ss = "https://pz.ihiof.ir/apicap";
      } else {
        ss = "https://pz.ihiof.ir/apicap";
      }

      ss = this.baseaddress;
      axios
        .post(
          ss + "/jwtsamotp2",
          {
            user: this.user,
            pass: this.pass,
            os: this.ostan,
          },
          axiosConfig
        )
        .then((response) => {
          localStorage.setItem("auth", response.data.token);
          console.log(response.data);
          //console.log(response.data.name);

          console.log("test ", response.data);

          this.$emit("successlogin", {
            chap: "0",
            user: response.data.idd,
            name: response.data.name,
            date: response.data.date,
            melli: response.data.melli,
            melli2: response.data.melli2,
          });
          this.countdown = 0;
          this.isshowing = false;
        })
        .catch((err) => {
          console.log("ffff");
          /*
          if(err.toJSON().message === 'Network Error'){
        alert('no internet connection');

        } */

          if (!err.response) {
            this.showtoast("ارتباط خود با اینترنت را چک کنید");
            console.log("قطع است ");
          } else {
            console.log(err.response.status);

            this.showtoast(" کد وارد شده صحیح نیست");
          }
        });

      setTimeout(() => {
        this.isshowing = false;
      }, 3000);
    },
    pishlogin2() {
      let axiosConfig = {
        headers: {
          oss: this.ostan,
          Authorization: "Bearer " + localStorage.getItem("auth"),
        },
      };

      var ss = window.location.protocol;
      if (ss == "https:") {
        ss = "https://pz.ihiof.ir/apicap";
      } else {
        ss = "https://pz.ihiof.ir/apicap";
      }

      ss = this.baseaddress;
      axios
        .post(
          ss + "/jwtsamsms",
          {
            user: this.user,
            pass: this.pass,
            os: this.ostan,
          },
          axiosConfig
        )
        .then((response) => {
          console.log(response.data);
          //console.log(response.data.name);

          console.log("test " + response.data.chap);
        })
        .catch((err) => {
          console.log("ffff");
          /*
          if(err.toJSON().message === 'Network Error'){
        alert('no internet connection');

        } */

          if (!err.response) {
            this.showtoast("ارتباط خود با اینترنت را چک کنید");
            console.log("قطع است ");
          } else {
            console.log(err.response.status);

            this.showtoast("نام کاربری یا رمز شما صحیح نیست");
          }
        });

      setTimeout(() => {
        this.isshowing = false;
      }, 3000);
    },
  },
};
</script>

<style>
.Vue-Toastification__toast--default.my-custom-toast-class {
  background-color: #c7087e !important;
  font-family: "IRAN";
  font-size: 20px;
  /*  margin-left: auto !important;
  margin-right: unset !important; */
}
/* .Vue-Toastification__container.top-right,
.Vue-Toastification__toast--default.my-custom-toast-class {
  font-family: "IRAN";
  font-size: 20px;
  margin-left: auto !important;
  margin-right: unset !important;
}
.Vue-Toastification__toast Vue-Toastification__toast--default top-right {
  font-family: "IRAN";
  font-size: 20px;
  margin-left: auto !important;

  margin-right: unset !important;
}

.Vue-Toastification__toast,
.Vue-Toastification__toast--rtl {
  font-family: "IRAN" !important;
  font-size: 20px !important;
   margin-left: auto !important;

      margin-right: unset !important;
} */

.v-alert {
  margin-bottom: 0 !important;
}

.test2 {
  position: relative;
  top: 0px;
}

.kadr {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.neo {
  border-radius: 50px;
  background: #27ca27;
  box-shadow: 20px 20px 60px #16789e, -20px -20px 60px #2a0e91;
}

.glas {
  background: rgba(198, 255, 138, 0.25);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.rizeh {
  font-size: 13px;
}

#appv {
  margin-top: 32px;
  font-size: 12px;
  color: #075b70;
}
.img2 {
  width: 21px;
  height: 21px;
  vertical-align: middle;
}

.red-image {
  filter: brightness(0) saturate(100%) hue-rotate(0deg) invert(0) sepia(100%)
    contrast(100%);
}

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.mycenter input {
  text-align: center;
}

#step1 {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

#step2 {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
